export default __webpack_public_path__ + "static/why-choose-f247193a2a0bbe2b7d9ca9d91754e040.webp";